import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"

export const ContentWrapper = styled.div`
  margin: 32px 0px;

  @media (min-width: ${Breakpoints.md}) {
    margin: 64px 0px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin: 96px 0px;
  }
`
